// extracted by mini-css-extract-plugin
export default {"title":"notion_title__2zuAp","table":"notion_table__2JQ5L"};